import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');
import { GoodBase } from './GoodBase';

export class Service extends GoodBase {
    _originalTypeClassName = "zERP.BO.Service";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Service.translate = translateService;
}
super();
this.Notes = null;
this.Price = null;
this.AdditionalInfo = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
Notes:any;
Price:any;
AdditionalInfo:any;

static GetCodeClassName(): any{return "Service";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}